import { render, staticRenderFns } from "./courseWidge.vue?vue&type=template&id=571b6f7c&scoped=true"
import script from "./courseWidge.vue?vue&type=script&lang=js"
export * from "./courseWidge.vue?vue&type=script&lang=js"
import style0 from "./courseWidge.vue?vue&type=style&index=0&id=571b6f7c&prod&lang=scss&scoped=true"
import style1 from "./courseWidge.vue?vue&type=style&index=1&id=571b6f7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571b6f7c",
  null
  
)

export default component.exports